import React from "react";
import cx from "classnames";
import { IWalletComponent } from "@novel/shared/components/ConnectWalletComponent/types";
import IconSwapper from "@novel/shared/components/ConnectWalletComponent/wallets/WalletConnectComponent/IconSwapper";
import { useAsyncCallback } from "@novel/shared/utils/useAsyncCallback";
import { AuthWallet } from "@novel/shared/utils/wallets/AuthWallet";
export function WalletConnectV2Component({
  onConnectWallet,
  isInGate,
  AuthWalletClass = AuthWallet
}: IWalletComponent): JSX.Element {
  const connectWalletConnect = useAsyncCallback(async () => {
    await new AuthWalletClass("wallet-connect-v2").ensureWalletAppInstalled(async wallet => onConnectWallet(await wallet.authenticate()));
  }, [onConnectWallet]);
  return <div className={cx("connect-wallet-button", isInGate && "connect-wallet-button-in-gate")} onClick={connectWalletConnect}>
            {isInGate ? <IconSwapper height="50px" width="50px" /> : <IconSwapper />}
            {isInGate ? <div className="connect-wallet-name-description-updated">
                    <span className="Connect-title-field-updated">Wallet Connect V2</span>
                </div> : <div className="connect-wallet-name-description">
                    <span className="Connect-title-field">Connect V2</span>
                    <div className="connect-wallet-explanation-text">For all other wallets</div>
                </div>}
        </div>;
}